import { createApp } from "vue";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@sharedStyle/styles.scss"; // Ensures Webpack includes it
import "@publicStyle/public.scss"; // Ensures Webpack includes it
import "@mdi/font/css/materialdesignicons.css";
import NotificationsSignupForm from "@publicComponents/product/NotificationsSignupForm.vue";
import {
  parseBoolean,
  normalizeAndalePluginsPublicData,
} from "@sharedJs/libs/utils.js";

normalizeAndalePluginsPublicData();

document.addEventListener("DOMContentLoaded", async () => {
  const el = document.getElementById("smartStockNotificationSignupApp");
  const signupForms = document.querySelectorAll(
    ".smart-stock-notification-signup-app",
  );
  // const el = document.querySelector(".smart-stock-notification
  if (signupForms.length > 0) {
    // await import("@sharedStyle/styles.scss"); // Load styles dynamically to avoid global interference

    const vuetify = createVuetify({
      components,
      directives,
      icons: {
        defaultSet: "mdi",
        sets: {
          mdi: {},
        },
      },
      defaults: {
        global: {
          styleReset: false, // Prevent Vuetify from applying global resets
        },
      },
    });

    signupForms.forEach((el) => {
      const initialProductId = el.dataset.initialProductId;
      const initialProductIsOutOfStock = parseBoolean(
        el.dataset.initialProductIsOutOfStock || false,
      );
      const isAutoInjected = parseBoolean(el.dataset.isAutoInjected || false);
      const notificationTypes = (el.dataset.notificationTypes || "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);
      const uiVariant = el.dataset.uiVariant || "";
      const uiLayout = el.dataset.uiLayout || "";
      const app = createApp(NotificationsSignupForm, {
        initialProductId: parseInt(initialProductId),
        initialProductIsOutOfStock: initialProductIsOutOfStock ? true : false,
        isAutoInjected: isAutoInjected,
        initialNotificationTypes: notificationTypes,
        initialUiVariant: uiVariant,
        initialUiLayout: uiLayout,
      });
      app.use(vuetify);
      app.mount(el);
    });
  }
});
